import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, wide = false, testid = "modal" }) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid={`${testid}-backdrop`}
        >
          <motion.div
            className={`modal-card ${wide ? "wide" : ""}`}
            initial={{ scale: 0.92, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 10 }}
            transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            data-testid={testid}
          >
            <div className="flex items-center justify-between px-7 pt-6 pb-4 border-b border-white/5 sticky top-0 bg-[#121215]/80 backdrop-blur-xl z-10">
              <h3 className="font-display text-xl tracking-tight">{title}</h3>
              <button onClick={onClose} className="text-zinc-500 hover:text-white p-1" data-testid={`${testid}-close`}>
                <X size={20} />
              </button>
            </div>
            <div className="p-7">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
